import { API_ROUTES } from '@/constants/apiRoutes';
import { ApiResponse, PaginatedApiResponse } from '@/react-query/context/ApiClientContextController';
import { queryFactoryOptions } from '@/react-query/utills/queryFactoryOptions';
import { AxiosInstance } from 'axios';
import { Customers, CustomersDetails, CustomersListParams } from './customers.types';

export const getCustomersList = (client: AxiosInstance) => async (params?: CustomersListParams) => {
  return (await client.get<PaginatedApiResponse<Customers[]>>(API_ROUTES.GET_CUSTOMER_LIST, { params })).data;
};

export const getCustomerDetail = (client: AxiosInstance) => async (customerId: string) => {
  return (
    await client.get<ApiResponse<CustomersDetails>>(API_ROUTES.GET_CUSTOMER_DETAIL, {
      params: { customerId: customerId || '' },
    })
  ).data;
};

export const customersQueries = {
  all: () => ['customers'],
  list: (params?: CustomersListParams) =>
    queryFactoryOptions<PaginatedApiResponse<Customers[]>>({
      queryKey: [...customersQueries.all(), 'list', params],
      queryFn: (client: AxiosInstance) => () => getCustomersList(client)(params),
    }),
  detail: (customerId: string) =>
    queryFactoryOptions<ApiResponse<CustomersDetails>>({
      queryKey: [...customersQueries.all(), 'detail', customerId],
      queryFn: (client: AxiosInstance) => () => getCustomerDetail(client)(customerId),
    }),
};
